<template>
  <div class="wrap">
    <div class="toolbar">
      <div class="title">每日订单统计报表</div>
      <div class="actions">
        <el-form :inline="true">
          <el-form-item label="统计日期">
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="loading" @click="search">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <el-main class="flex-container">
      <el-table
        :data="list"
        border
        stripe
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <el-table-column type="index" label="序号" width="60" />
        <el-table-column prop="dt" label="统计日期" width="120" />
        <el-table-column prop="orderCount" label="订单总数" width="100" />
        <el-table-column prop="orderUserCount" label="下单用户数" width="110" />
        <el-table-column prop="totalOrderAmount" label="总金额(元)" width="140" />
        <el-table-column prop="avgOrderAmount" label="均价(元)" width="110" />
        <el-table-column prop="totalProductNum" label="总销售件数" width="110" />
        <el-table-column prop="productSkuNum" label="销售种类数" width="110" />
      </el-table>

      <div class="chart" ref="chart" />
    </el-main>

    <el-footer class="el-footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </el-footer>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'DailyOrderStat',
  data() {
    return {
      loading: false,
      dateRange: [],
      list: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      chart: null,
      resizeHandler: null,
    }
  },
  computed: {
    xDates() {
      return (this.list || []).map(i => i.dt)
    },
    yOrderCounts() {
      return (this.list || []).map(i => this.toNumber(i.totalOrderAmount))
    },
  },
  mounted() {
    this.getData()
    this.resizeHandler = () => {
      if (this.chart) this.chart.resize()
    }
    window.addEventListener('resize', this.resizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler)
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
    if (this.searchTimer) {
      clearTimeout(this.searchTimer)
      this.searchTimer = null
    }
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    search() {
      this.currentPage = 1
      this.getData()
    },
    toNumber(v) {
      const n = Number(v)
      return Number.isFinite(n) ? n : 0
    },
    getData() {
      this.loading = true
      this.$axios.get('/hadoop/dailyOrderStat', {
        params: {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          startDate: this.dateRange[0] || '',
          endDate: this.dateRange[1] || '',
        },
      })
        .then(res => {
          this.total = res.data.data.total
          this.list = res.data.data.records
          this.loading = false
          this.$nextTick(() => this.renderChart())
        })
        .catch(() => {
          this.loading = false
        })
    },
    renderChart() {
      const el = this.$refs.chart
      if (!el) return
      if (!this.chart) this.chart = echarts.init(el)

      const option = {
        title: { text: '每日订单数量趋势', left: 'center' },
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        grid: { left: 80, right: 30, top: 80, bottom: 30 },
        xAxis: { type: 'value', name: '订单数量' },
        yAxis: { type: 'category', data: this.xDates, inverse: true, name: '统计日期' },
        series: [
          {
            name: '订单数量',
            type: 'bar',
            data: this.yOrderCounts,
            itemStyle: { color: '#409EFF' },
            label: { show: true, position: 'right' },
          },
        ],
      }
      this.chart.setOption(option, true)
    },
  },
}
</script>

<style scoped>
.wrap {
  padding: 16px;
}
.toolbar {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.title {
  font-size: 18px;
  font-weight: 700;
  color: #303133;
  line-height: 32px;
}
.actions {
  display: flex;
  align-items: center;
  margin-left: 100px;
}
.chart {
  height: 1000px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  flex-shrink: 0;
  width: 800px;
}
.flex-container {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/views/DailyOrderStat.vue